import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import { useTranslation } from 'react-i18next';
import { calculaTempo } from '../../global';

import './styles.css';

export default function Notificacoes() {
  const history = useHistory();
  const { t } = useTranslation();
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');

  useEffect(() => {
    let cancelled = false;
    loadingRef.current = true;
    setLoadingMore(true);

    api.get(`/v5/users/me/notifications?page=${page}`, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
      },
    }).then((response) => {
      if (cancelled) return;
      const data = Array.isArray(response.data) ? response.data : [];
      setPosts((prev) => (page === 1 ? data : prev.concat(data)));
      setHasMore(data.length > 0);
    }).catch(() => {
      if (!cancelled) history.push('/');
    }).finally(() => {
      if (!cancelled) {
        loadingRef.current = false;
        setLoadingMore(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [USER_EMAIL, USER_TOKEN, history, page]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      if (loadingRef.current || !hasMore) return;
      setPage((current) => current + 1);
    }, { rootMargin: '240px' });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, posts.length]);

  function abrirNotificacao(post) {
    if (post.resource_id) {
      sessionStorage.setItem('sPostDetalhe', JSON.stringify(post));
      history.push(`/post/${post.resource_id}`);
    }
  }

  return (
    <FeedLayout active="notifications">
      <div className="notificacoes-container">
        <div className="feed-top">{t('pages.notifications.title')}</div>
        <section className="body">
          <ul>
            {posts.map((post, index) => (
              <li
                key={post.id || index}
                className={post.resource_id ? 'is-clickable' : ''}
                onClick={() => abrirNotificacao(post)}
              >
                <p className="notif-time">{calculaTempo(post.created_at)}</p>
                <p className="notif-text">{post.full_text}</p>
              </li>
            ))}
          </ul>
          <div className="feed-sentinel" ref={sentinelRef}>
            {loadingMore && <span>Carregando mais notificações…</span>}
            {!loadingMore && !hasMore && posts.length > 0 && (
              <span>Você viu as notificações mais recentes</span>
            )}
            {!loadingMore && posts.length === 0 && (
              <span>Nenhuma notificação no momento</span>
            )}
          </div>
        </section>
      </div>
    </FeedLayout>
  );
}
